import { IAppState } from '../../store';

export const selectAnswerFormState = (state: IAppState) => state.answerForm.state;
